/**
 * // TODO (jeremy): target should be a Module eventually
 * A light-weight event.
 *
 * @constructor
 * @param {string} type The name of the event type
 * @param {Object} target The event dispatcher
 * @param {Object} data the event payload
 */
const DenzelEvent = function(type, target, data) {
  /** @type {string} */
  this.type = type;

  /** @type {Object} */
  this.target = target;

  /** @type {Object} */
  this.currentTarget = target;

  /** @type {Object} */
  this.data = data || {};

  /** @type {boolean} */
  this.stopped = false;
};

/**
 */
DenzelEvent.prototype.stopPropagation = function() {
  this.stopped = true;
};

/**
 * @return {boolean}
 */
DenzelEvent.prototype.shouldPropagate = function() {
  return !this.stopped;
};

export default DenzelEvent;
